module.exports = __webpack_public_path__ + "static/img/detail_fy01.bfcac5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail_fy01.png
// module id = i7y6
// module chunks = 2